import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { getApproximateTotalSum } from '../helpers/hocs'


export default ({ sum }) => {
  let total = getApproximateTotalSum(sum)

  return (
    <div className='Hero'>
      <div className='Hero__header'>
        <span className='Hero__total'>Более 610 млн ₽</span>
        <span className='SubHead Hero__total-caption'>
          <FormattedHTMLMessage id='hero.for_charity' />
        </span>
      </div>
      <div className='Hero__caption-wrap'>
        <p className='SubHead Hero__caption'>
          <FormattedHTMLMessage id='hero.good_excuse' />
        </p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Hero.jsx